// extracted by mini-css-extract-plugin
export default {"calendar-box":"CalendarBox_calendar-box__u4aBZ"};